module.exports = __webpack_public_path__ + "catalog/items/firesafety/Exit-Up/Exit-Up.svg";